import axios from 'axios'
import {BASE_PATH} from '@/utils/base-path'

export default {
    getJwtUser (code) {
        let url = process.env.VUE_APP_BASE_API_URL + '/social/jwt_user/fptid/'
        let bodyFormData = new FormData()
        bodyFormData.append('code', code)
        bodyFormData.append('redirect_uri', `${window.location.origin}${BASE_PATH}authentication/fpt-id/success/`)
        let instance = axios.create({
            headers: {
                common: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        })
        return instance.post(url, bodyFormData)
    },
    getProfile () {
        return window.$http.get('/profile/')
    }
}
